export enum PartRequestActionState {
  Pending = 'pending',
  Approved = 'approved',
  Issued = 'issued',
  Rejected = 'rejected'
}